<template class="t-container">
    <div>
        <span>{{ content }}</span>
    </div>
</template>
<script>
export default {
    props: ["content"],
    methods: {},
};
</script>
<style>
.t-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: rgb(255, 87, 51);
    color: white;
    font-size: smaller;
}

.vue-toast {
    background-color: rgb(255, 87, 51);
    color: white;
    font-size: smaller;
}
</style>
